import React from 'react'
import Skeleton from 'react-loading-skeleton'

function AllFaqSkeleton() {
  return (
         <div className="container space-bloc">
           <div className="row">
             <div className="col-md-5">
               <h2>
                 <Skeleton width="60%" height={30} />
               </h2>
               <p>
                 <Skeleton width="90%" height={20} count={3} />
               </p>
             </div>
             <div className="col-md-7">
               <div className="skeleton-accordion">
                 {[...Array(3)].map((_, index) => (
                   <div key={index} style={{ marginBottom: '20px' }}>
                     <Skeleton width="80%" height={25} />
                     <Skeleton width="95%" height={15} style={{ marginTop: '10px' }} />
                     <Skeleton width="90%" height={15} style={{ marginTop: '5px' }} />
                   </div>
                 ))}
               </div>
             </div>
           </div>
         </div>
  )
}

export default AllFaqSkeleton